// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"5775a411","369":"cb24811b","633":"0f6b7461","788":"7b087d6b","842":"da476895","946":"446c11e7"}[chunkId] + ".chunk.js";
};